const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/member_tags/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { memberTagsSearchSchema } from "@circle-react/components/SettingsApp/MemberTags/ListMemberTags/searchParams";
import { memberTagRoutes } from "@circle-react/lib/routes/memberTags";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { parse } from "qs";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/member_tags/")({
  validateSearch: memberTagsSearchSchema,
  beforeLoad: ({
    location
  }) => {
    const search = parse(location.searchStr, {
      ignoreQueryPrefix: true
    });
    if (search.q && typeof search.q === "object") {
      // TanStack serializes numeric bracket values again before beforeLoad runs.
      const browserSearch = parse(window.location.search, {
        ignoreQueryPrefix: true
      });
      const rawSearch = window.location.pathname === location.pathname && browserSearch.q && typeof browserSearch.q === "object" ? browserSearch : search;
      redirect({
        to: memberTagRoutes.list.path,
        search: memberTagsSearchSchema.parse(rawSearch),
        replace: true,
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});